import { useState } from "react"
import ActionDropdown from "../../../common/AdminCommonComponents/Buttons/ActionDropdown/ActionDropdown"
import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import DynamicTableFilters from "../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters"
import DynamicCardRow from "../../DynamicCardRow/DynamicCardRow"
import AddNewAttribute from "../AddNewAttribute/AddNewAttribute"

const AttributesManagementOverview = () => {

  const [addNew, setAddNew] = useState(false)

  const cardsData = [
    { title: "TOTAL ATTRIBUTES", value: 0 },
    { title: "ACTIVE", value: 0 },
    { title: "INACTIVE", value: 0 },
  ]

  const actions = [
    { label: 'Edit', action: () => console.log('edit') },
    { label: 'Change Status', action: () => console.log('Change Status') },
    { label: 'Delete', action: () => console.log('Delete') },
  ]

  const tableData = [
    {
      attributeId: "#12346",
      attributeName: "Color",
      type: "Dropdown",
      category: "Clothing",
      subCategories: "Men’s Pants, Women’s Dresses",
      values: "Red, Blue, Green",
      status: "Active",
    },
    {
      attributeId: "#12346",
      attributeName: "Size",
      type: "Dropdown",
      category: "Clothing",
      subCategories: `T-Shirts Pants`,
      values: "Red, Blue, Green",
      status: "Active",
    },
    {
      attributeId: "#12346",
      attributeName: "Material",
      type: "Text Field",
      category: "Furniture",
      subCategories: "Sofas, Chairs",
      values: "Red, Blue, Green",
      status: "Inactive",
    },
    {
      attributeId: "#12346",
      attributeName: "Warranty Period",
      type: "Number field",
      category: "Electronics",
      subCategories: "Refrigerators, Washing machines",
      values: "Red, Blue, Green",
      status: "Active",
    },
    {
      attributeId: "#12346",
      attributeName: "Color",
      type: "Dropdown",
      category: "Clothing",
      subCategories: "Men’s Pants, Women’s Dresses",
      values: "Red, Blue, Green",
      status: "Active",
    },
  ]
  
  const columns = [
    { name: 'Attribute ID', selector: (row) => row.attributeId },
    { name: 'Attribute Name', selector: (row) => row.attributeName },
    { name: 'Type', selector: (row) => row.type },
    { name: 'Category', selector: (row) => row.category },
    { name: 'Sub Categories', selector: (row) => row.subCategories },
    { name: 'Values', selector: (row) => row.values },
    { name: 'Status', selector: (row) => row.status },
    { name: 'Action', cell: () => <ActionDropdown options={actions} /> }
  ]

  return (
    <>
      <div className="shadow bg-white p-3 mt-3">
        <div className="mb-3 fw-semibold fs-4">Attributes Overview</div>
        <DynamicCardRow cards={cardsData} />
      </div>

      <div className="shadow bg-white mt-3">
      {!addNew ? (
          <>
            <div className="p-3 d-flex align-items-center justify-content-between">
              <div className="fw-semibold fs-5">Attributes Management</div>
              <DynamicButton theme="blue" onClick={() => setAddNew(true)}>
                Add new
              </DynamicButton>
            </div>

            <DynamicTableFilters componentName="Attributes Management Overview" />

            <div className="mt-2">
              <DynamicDatatable columns={columns} data={tableData} type="yellow" />
            </div>
          </>
        ) : (
          <div className="p-3">
            <AddNewAttribute setAddNew={setAddNew} />
          </div>
        )}
      </div>
    </>
  )
}

export default AttributesManagementOverview
